export default __webpack_public_path__ + "static/media/gonfalone.0fb8ebec.jpg";